import a, { useState as f, useRef as p, useCallback as m } from "react";
import { C as d } from "./chunk.hn4xKC_I.js";
import { E as h, W as C, I as b } from "./chunk.9nF0J5xs.js";
import { Typography as x, useTheme as g, Button as u } from "@mui/material";
import { C as w } from "./chunk.C6aG2Vyu.js";
import { I as c } from "./chunk.zlc_6vey.js";
function v(e, t, n = !1) {
  const l = y(), r = {
    info: t.palette.info.main,
    success: t.palette.success.main,
    warning: t.palette.warning.main,
    error: t.palette.error.main,
    white: t.palette.common.white
  }, s = {
    info: t.palette.info.light,
    success: t.palette.success.light,
    warning: t.palette.warning.light,
    error: t.palette.error.light
  };
  switch (e) {
    case "info":
      return {
        icon: /* @__PURE__ */ a.createElement(
          b,
          {
            "aria-label": "Info Outlined Icon",
            sx: {
              color: n ? r.white : r.info,
              ...l
            }
          }
        ),
        color: r.info,
        bgColor: s.info
      };
    case "success":
      return {
        icon: /* @__PURE__ */ a.createElement(
          d,
          {
            "aria-label": "Check Circle Icon",
            sx: {
              color: n ? r.white : r.success,
              ...l
            }
          }
        ),
        color: r.success,
        bgColor: s.success
      };
    case "warning":
      return {
        icon: /* @__PURE__ */ a.createElement(
          C,
          {
            "aria-label": "Warning Amber Icon",
            sx: { color: t.palette.warning.dark, ...l }
          }
        ),
        color: r.warning,
        bgColor: s.warning
      };
    case "error":
      return {
        icon: /* @__PURE__ */ a.createElement(
          h,
          {
            "aria-label": "Error Outlined Icon",
            sx: {
              color: n ? r.white : r.error,
              ...l
            }
          }
        ),
        color: r.error,
        bgColor: s.error
      };
  }
}
function y() {
  return {
    width: "20px",
    height: "20px",
    marginTop: "2px"
  };
}
function I(e, t) {
  const n = e.trim();
  let r = document.createElement("canvas").getContext("2d");
  if (!r)
    return;
  r.font = `${t.typography.subtitle2.fontWeight} ${t.typography.subtitle2.fontSize} ${t.typography.subtitle2.fontFamily}`;
  let s = r.measureText(n);
  const o = n.length * parseFloat(t.typography.subtitle2.letterSpacing);
  return s.width + o;
}
function R(e, t, n, l, r = 0, s = 0) {
  const o = I(e, t);
  if (!o)
    return !1;
  let i = parseInt(t.spacing(2));
  return r && (i += parseInt(t.spacing(2))), s && (i += parseInt(t.spacing(1))), o + n + r + s + i >= l;
}
const O = (e) => /* @__PURE__ */ a.createElement(
  x,
  {
    variant: "subtitle2",
    sx: {
      display: e.shouldWrap ? "block" : "inline-block",
      overflowWrap: "anywhere",
      maxWidth: e.maxWidth,
      // Temporarily add this to override Single UI use of V2 typography
      fontSize: "14px",
      fontWeight: 500,
      letterSpacing: "0.1px",
      lineHeight: "24px"
    }
  },
  e.message
), z = ({
  action: e,
  ...t
}) => {
  const n = g();
  return /* @__PURE__ */ a.createElement(
    u,
    {
      ref: t.ctaRef,
      size: "small",
      onClick: (l) => {
        e == null || e.onClick(l), e != null && e.closeOnClick && t.onClose && t.onClose(l);
      },
      sx: {
        display: "flex",
        float: "right",
        marginLeft: t.shouldWrap ? t.bannerCTA ? void 0 : "auto" : t.isPrimary ? n.spacing(2) : void 0,
        marginTop: t.shouldWrap ? t.bannerCTA ? n.spacing(1) : n.spacing(2) : void 0,
        maxWidth: "100%"
      },
      startIcon: (e == null ? void 0 : e.startIcon) && /* @__PURE__ */ a.createElement(c, { icon: e == null ? void 0 : e.startIcon }),
      endIcon: (e == null ? void 0 : e.endIcon) && /* @__PURE__ */ a.createElement(c, { icon: e == null ? void 0 : e.endIcon }),
      "data-testid": e == null ? void 0 : e["data-testid"]
    },
    e == null ? void 0 : e.buttonText
  );
}, F = (e) => {
  const t = g();
  return /* @__PURE__ */ a.createElement(
    u,
    {
      ref: e.closeButtonRef,
      onClick: e.onClose,
      "aria-label": "Snackbar Close Button",
      size: "small",
      sx: {
        float: "right",
        marginLeft: t.spacing(2)
      }
    },
    /* @__PURE__ */ a.createElement(w, { sx: { width: t.spacing(2), height: t.spacing(2) } })
  );
}, B = (e, t = !1) => {
  const [n, l] = f(0), r = p(null);
  return [m(
    (o) => {
      if (o !== null)
        if (t) {
          const i = window.getComputedStyle(o);
          l(
            o.getBoundingClientRect().width - parseFloat(i.getPropertyValue("padding-left")) - parseFloat(i.getPropertyValue("padding-right"))
          );
        } else
          l(o.getBoundingClientRect().width);
      else
        l(0);
      r.current = o;
    },
    [e]
  ), n];
};
export {
  F as A,
  O as a,
  z as b,
  R as c,
  y as g,
  v as s,
  B as u
};
